module.exports = __webpack_public_path__ + "img/jxflogo.112ea0c8.png";